import React from "react";
import { LineChart } from "@carbon/charts-react";

const Ltv = () => {
  const data = [
    {
      group: "Gross NPA",
      key: "Jan 2024",
      value: 2.42,
    },
    {
      group: "Gross NPA",
      key: "Feb 2024",
      value: 2.35,
    },
    {
      group: "Gross NPA",
      key: "Mar 2024",
      value: 1.31,
    },
    {
      group: "Gross NPA",
      key: "Apr 2024",
      value: 2.23,
    },
    {
      group: "Gross NPA",
      key: "May 2024",
      value: 1.23,
    },
    {
      group: "Gross NPA",
      key: "June 2024",
      value: 1.23,
    },

    {
      group: "Net NPA",
      key: "Jan 2024",
      value: 3.42,
    },
    {
      group: "Net NPA",
      key: "Feb 2024",
      value: 5.6,
    },
    {
      group: "Net NPA",
      key: "Mar 2024",
      value: 4.23,
    },
    {
      group: "Net NPA",
      key: "Ap 2024",
      value: 2.14,
    },
    {
      group: "Net NPA",
      key: "May 2024",
      value: 5.0,
    },
    {
      group: "Net NPA",
      key: "June 2024",
      value: 3.0,
    },
  ];
  const options = {
    // title: "Values in %",

    data: {
      selectedGroups: ["Gross NPA", "Net NPA"],
    },
    axes: {
      bottom: {
        // title: "2023 Annual Sales Figures",
        mapsTo: "key",
        scaleType: "labels",
      },
      left: {
        mapsTo: "value",
        // title: "Conversion rate",
        scaleType: "linear",
      },
    },
    height: "250px",
    legend: {
      position: "bottom",
      alignment: "center",
    },
    toolbar: {
      enabled: false,
    },
  };

  const PeerComparisonRes = [
    {
      bank: "ICICI Bank",
      peekPercentage: "22",
      discountFactor: "18",
      Ltv: "60",
    },
    {
      bank: "Axis Bank",
      peekPercentage: "18",
      discountFactor: "16",
      Ltv: "44",
    },
    {
      bank: "Kotak Mahidra Bank",
      peekPercentage: "20",
      discountFactor: "14",
      Ltv: "42",
    },
    {
      bank: "HDFC Bank Ltd",
      peekPercentage: "22",
      discountFactor: "18",
      Ltv: "35",
    },
    {
      bank: "ITC Ltd",
      peekPercentage: "24",
      discountFactor: "20",
      Ltv: "40",
    },
  ];
  return (
    <div className="m-4">
      <p className="text-[#333333] font-bold text-2xl mb-4">LTV</p>
      <div className="flex flex-row gap-4">
        <div className="border border-solid border-[#E0E0E0] w-[450px] h-max rounded-2xl p-4 flex flex-col gap-4 overflow-x-auto no-scrollbar">
          <p className="font-semibold text-sm text-[#333333]">
            Gross NPA & Net NPA
          </p>
          <LineChart data={data} options={options}></LineChart>
        </div>
      </div>
      <div className="border border-solid border-[#E0E0E0] w-[450px] h-[203px] rounded-2xl p-4 flex flex-col gap-4 mt-4">
        <p className="font-semibold text-sm text-[#333333]">Peer Comparison</p>
        <div className="w-[418px] h-[135px] flex flex-col gap-4 ">
          <div className="flex flex-row justify-between">
            <p className="font-semibold text-xs text-[#000000] mr-4 ">
              Stock Name
            </p>
            <p className="font-semibold text-xs text-[#000000]">
              Peak to Trough
            </p>
            <p className="font-semibold text-xs text-[#000000]">
              Discount Factor
            </p>
            <p className="font-semibold text-xs text-[#000000] mr-3">LTV</p>
          </div>
          <div className=" h-fit overflow-y-auto no-scrollbar">
            {PeerComparisonRes.map((peer) => (
              <div className="flex flex-row justify-between py-2 px-2 bg-[#fbf8f8]">
                <p className="w-[80px] font-semibold text-xs text-[#000000] overflow-hidden whitespace-nowrap text-ellipsis mr-4">
                  {peer.bank}
                </p>
                <p className="font-semibold text-[10px] text-[#000000] text-right w-[65px]">
                  {peer.peekPercentage}%
                </p>
                <p className="font-semibold text-[10px] text-[#000000] w-[85px] text-right">
                  {peer.discountFactor}%
                </p>
                <p className="font-semibold text-[10px] text-[#000000] ">
                  {peer.Ltv}%
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ltv;
